import React from 'react';
import { graphql } from 'react-apollo';
import MUIDataTable from "mui-datatables";
import { Grid } from '@material-ui/core';
import { Settings as SettingsIcon } from '@material-ui/icons';
import DrawerPlacements from '../../../../components/DrawerPlacements';
import { LayoutTypesLookup } from "../../../layoutTypes/components/lookup";
import PageError from '../../../../components/PageError';
import PageLoading from '../../../../components/PageLoading';
import { GET_BY_PUBLISHER_ID } from "../../../../queries/settings";
import AddSettings from "../actions/create";
import UpdateSettings from '../actions/edit';
import Delete from '../actions/delete';

const settingsSiteFunc = ({publisherId, data: { settingByPublisherId, loading, error }}) => {
    const actionsRow = (tableMeta) => {
      const url = tableMeta.rowData[0];
      const layoutTypeId = tableMeta.rowData[1];
      const id = tableMeta.rowData[2];
      const publisherIdOnRow = tableMeta.rowData[3];
      const trigger = tableMeta.rowData[4];
      const condition = tableMeta.rowData[5];
      const infiniteScroll = tableMeta.rowData[6];
      return (
        <DrawerPlacements title="Edit Settings" labeButtonAction={url}>
        <UpdateSettings id={id} layoutTypeId={layoutTypeId} url={url} publisherId={publisherIdOnRow} trigger={trigger} condition={condition} infiniteScroll={infiniteScroll}/>
        </DrawerPlacements>
      );
    }
  
    const DrawerAdd = () => {
      return (
        <DrawerPlacements title="Add Setting" labeButtonAction="Add">
          <AddSettings publisherId={publisherId}/>
        </DrawerPlacements>
      );
    }
  
    const options = {
      selectableRows: 'checkbox',
      responsive: "scrollMaxHeight",
      customToolbarSelect: selectedRows => (
          <Delete selectedRows = {selectedRows} settingsData={settingByPublisherId} publisherId={publisherId}/>
        )
    };
  

  return (
    <>
      <DrawerPlacements headerButton="off" title="Settings" iconButtonAction={<SettingsIcon />}>
      
        <Grid xs={3} item style={{position : 'absolute', top : 10, right : 10, width : '25%'}}>
          {DrawerAdd()}
        </Grid>
        {
        (loading) ? <PageLoading /> : 
        (error) ? <PageError /> :
        (
            <MUIDataTable
              title={false}
              data={settingByPublisherId}
              columns={[{
                label : 'Url',
                name  : 'url',
                options : {
                  customBodyRender: (value, tableMeta, updateValue) => { 
                    return (actionsRow(tableMeta));
                  }
                }
              },
              {
                label: "Layout Type",
                name: "layoutType.id",
                options: {
                  filter: true,
                  customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <LayoutTypesLookup layoutTypeId={value}/>
                    );
                  }
                }
              },
                {
                name : "id",
                options: {
                  display : false
                }
              },{
                name : "publisherId",
                options: {
                  display : false
                }
              },{
                label: "Trigger",
                name : "trigger",
                options: {
                  display : true
                }
              },{
                label: "Condition",
                name : "condition",
                options: {
                  display : true
                },
              },
              {
                name : "infiniteScroll",
                options: {
                  display : false
                }
              },
            ]} 
              options={options}
            />
        )
        }
      </DrawerPlacements>

    </>
  );
}

export const SettingsSite = graphql(GET_BY_PUBLISHER_ID, {options: (props) =>({ variables: { publisherId: props.publisherId }})})(settingsSiteFunc);